export default {
  namespaced: true,
  state: () => ({
    isOpen: false
  }),
  mutations: {
    TOGGLE_SIDEBAR (state, payload) {
      state.isOpen = payload
    }
  },
  actions: {},
  getters: {}
}
